"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisibilityType = exports.eVisibilityType = exports.TelematicsType = exports.eTelematicsType = void 0;
const utils_1 = require("@loadsure/utils");
const visibility_class_1 = __importDefault(require("./visibility.class"));
var eTelematicsType;
(function (eTelematicsType) {
    eTelematicsType["VEHICLE_LEVEL"] = "VEHICLE_LEVEL";
    eTelematicsType["CONTAINER_LEVEL"] = "CONTAINER_LEVEL";
    eTelematicsType["COMMODITY_LEVEL"] = "COMMODITY_LEVEL";
})(eTelematicsType = exports.eTelematicsType || (exports.eTelematicsType = {}));
var TelematicsType;
(function (TelematicsType) {
    const data = {
        [eTelematicsType.VEHICLE_LEVEL]: "Vehicle Level",
        [eTelematicsType.CONTAINER_LEVEL]: "Container Level",
        [eTelematicsType.COMMODITY_LEVEL]: "Commodity Level"
    };
    function getItems() {
        return utils_1.objectToItems(data);
    }
    TelematicsType.getItems = getItems;
    function getName(value = "") {
        return data[value];
    }
    TelematicsType.getName = getName;
})(TelematicsType = exports.TelematicsType || (exports.TelematicsType = {}));
var eVisibilityType;
(function (eVisibilityType) {
    eVisibilityType["PRIMARY_MODE_ONLY"] = "PRIMARY_MODE_ONLY";
    eVisibilityType["SECONDARY_MODE_ONLY"] = "SECONDARY_MODE_ONLY";
    eVisibilityType["ENTIRE_JOURNEY"] = "ENTIRE_JOURNEY";
})(eVisibilityType = exports.eVisibilityType || (exports.eVisibilityType = {}));
var VisibilityType;
(function (VisibilityType) {
    const data = {
        [eVisibilityType.PRIMARY_MODE_ONLY]: "Primary Mode Only",
        [eVisibilityType.SECONDARY_MODE_ONLY]: "Secondary Modes Only",
        [eVisibilityType.ENTIRE_JOURNEY]: "Entire Journey"
    };
    function getItems() {
        return utils_1.objectToItems(data);
    }
    VisibilityType.getItems = getItems;
    function getName(value = "") {
        return data[value];
    }
    VisibilityType.getName = getName;
})(VisibilityType = exports.VisibilityType || (exports.VisibilityType = {}));
exports.default = visibility_class_1.default;
//# sourceMappingURL=index.js.map